// extracted by mini-css-extract-plugin
export default {"noselect":"Global_noselect__j4fdg","grow_on_hover":"Global_grow_on_hover__TydXY"};